// The hashed module script a page started from (the production build's /assets/index-<hash>.js), read without loading anything else, so the release watch and the feedback details share it; pages without one (the dev server, tests) answer null.
const ENTRY_SELECTOR = 'script[type="module"][src^="/assets/"]';

export function entryScript(root: ParentNode): string | null {
  return root.querySelector<HTMLScriptElement>(ENTRY_SELECTOR)?.getAttribute("src") ?? null;
}
